import React, { createContext, useState, useEffect, useContext } from "react";
import db from "../products/Products.database.js";
import { useParams } from "react-router-dom";

const ProductsContext = createContext();

export const useProducts = () => useContext(ProductsContext);

// TODO: This code is not working properly. Fix it in the future so that I get the product information from the url and then store it in context  
export const ProductsProvider = ({ children }) => {
  const { id } = useParams();
  const [products, setProducts] = useState([]);
  const [item, setItem] = useState({
    name: "",
    price: "",
    description: "",
    image: "",
    category: [],
    id: "",
  });

  // useEffect(() => {
  //   if (id) {
  //     const { products } = db();
  //     const foundProduct = products.find(
  //       (product) => product.id === parseInt(id)
  //     );
  //     if (foundProduct) {
  //       setItem({
  //         name: foundProduct.title,
  //         price: foundProduct?.price || '',
  //         description: foundProduct.description || "",
  //         image: foundProduct.image,
  //         category: foundProduct?.category || [],
  //         rating: foundProduct?.rating ? Number(foundProduct.rating) : 0,
  //         id: foundProduct.id,
  //       });
  //     } else {
  //       console.log('Product not found in database');
  //     }
  //   }
  // }, [id, setItem]);
  
  
  
  
  const saveItem = (product) => {
    const { title, image } = product;
    setItem({
      ...item,
      name: title,
      image: image,
    });
  };

  const addProduct = (product) => {
    setProducts([...products, product]);
  };

  const updateProduct = (id, updatedProduct) => {
    setProducts(
      products.map((product) =>
        product.id === id ? { ...product, ...updatedProduct } : product
      )
    );
  };

  const deleteProduct = (id) => {
    setProducts(products.filter((product) => product.id !== id));
  };

  return (
    <ProductsContext.Provider
      value={{
        products,
        addProduct,
        updateProduct,
        deleteProduct,
        saveItem,
        item,
      }}
    >
      {children}
    </ProductsContext.Provider>
  );
};
